module.exports = __webpack_public_path__ + "static/media/pdf-file.10e7a638.svg";